import { Directive, effect, ElementRef, inject, input } from '@angular/core';
import { RouterLink, UrlTree } from '@angular/router';
import { OrganizationsStore } from '@cf/temp/services';

@Directive({
  selector: '[cfOrgRouterLink]',
})
export class OrgRouterLinkDirective {
  #orgStore = inject(OrganizationsStore);
  #elementRef = inject(ElementRef);

  routerLinkDirective = inject(RouterLink);
  routerLink = input<any[] | string | UrlTree | null | undefined>();
  cfOrgRouterLink = input(true, { transform: (v) => v !== 'false' && v !== false });
  bindHref = input(false);

  constructor() {
    effect(() => {
      const orgScopeEnabled = this.cfOrgRouterLink();
      const orgId = this.#orgStore.selectedEntityId();
      const link = this.routerLink();
      const isUrlTree = link instanceof UrlTree;
      const bindHref = this.bindHref();
      if (!orgScopeEnabled) return;
      // this.routerLinkDirective;
      if (isUrlTree) {
        // eslint-disable-next-line no-untranslated-string/no-untranslated-string
        throw new Error('UrlTree is not supported');
      }
      if (link) {
        const finalLink = [
          '/org',
          orgId,
          ...(Array.isArray(link) ? link : [link])
            .flatMap((v) => (typeof v === 'string' ? v.split('/') : v))
            .filter(Boolean),
        ];
        this.routerLinkDirective.routerLink = finalLink.join('/');
        if (bindHref) {
          this.#elementRef.nativeElement.setAttribute('href', finalLink.join('/'));
        }
      }
    });
  }
}
